import { useMutation } from '@tanstack/react-query';
import { POST, POST_TRANSFER_UPDATE } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';

export const useTransferUpdate = ({ onSuccessCallBack }) => {
  return useMutation({
    mutationFn: async ({ oldTelephone, newTelephone, remark }) => {
      try {
        const payload = {
          oldTelephone,
          newTelephone,
          remark,
        };
        const response = await POST(POST_TRANSFER_UPDATE(), payload);
        if (onSuccessCallBack) onSuccessCallBack(response);
        return response;
      } catch (error) {
        throw { ...error, disabledThrow: true };
      }
    },
    onSuccess: (data) => {
      openAlert({
        model: 'message',
        type: 'success',
        message: data?.message,
      });
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message,
      });
    },
  });
};
